import Vue from 'vue';

export default {
  namespaced: true,

  state: {
    all: []
  },

  getters: {
    getValves(state) {
      return state.all;
    },

    // gets the next valve that is not yet used
    getNextValve(state, getters, rootState) {
      let array = state.all.map((v) => v.id);

      for (let key in rootState.valves.all) {
        if (array.includes(parseInt(key))) continue;

        return parseInt(key);
      }
      return -1;
    },

    getBuildObject(state) {
      let result = [];

      state.all.forEach((valve) => {
        result.push({
          block: 'A03',
          valve: valve.id,
          additionalValves: valve.additionalValves,
          a10: valve.a10,
        })
      });

      return result;
    }
  },
  actions: {
    addValve: ({ commit }) => {
      commit('addValve', null);
    },
    addValveToTheEnd: ({ commit }) => {
      commit('addValveToTheEnd', null);
    },

    switchValve({ state, commit, rootGetters }, { index, id }) {
      const valve = state.all[index];

      commit('updateValve', {
        index,
        valve: {
          ...valve,
          id
        }
      });
    },
  },
  mutations: {
    addValve(state, id) {
      state.all.push({
        block: 'A03',
        id,
        additionalValves: [],
      });
    },
    addValveToTheEnd(state, id) {
      state.all.unshift({
        block: 'A03',
        id,
        additionalValves: [],
      });
    },
    addValveWithAdditionalValves(state, {block, id, additionalValves}) {
      state.all.push({
        block,
        id,
        additionalValves,
      });
    },

    updateValve(state, { index, valve }) {
      Vue.set(state.all, index, valve);
    },
    updateValveProp(state, { index, name, value }) {
      Vue.set(state.all[index], name, value);
    },
    removeValve(state, index) {
      state.all.splice(index, 1);
    },

    addAdditionalValve(state, { valveIndex, id }) {
      state.all[valveIndex].additionalValves.push(parseInt(id));
    },

    updateAdditionalValve(state, { valveIndex, index, id }) {
      const valve = state.all[valveIndex];

      Vue.set(valve.additionalValves, index, id);
    },

    removeAdditionalValve(state, { valveIndex, index }) {
      state.all[valveIndex].additionalValves.splice(index, 1);
    },

    dropValves(state) {
      for(let i = 0; i < state.all.length; i ++) {
        state.all[i].additionalValves = [];
      }
      state.all = [];
    },

    updateAllValves(state, valves) {
      state.all = valves;
    }
  },
};
